import * as React from "react";
import { cn } from "../../lib/utils";

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

export function Input({ className, ...props }: InputProps) {
  return (
    <input
      className={cn(
        "bg-transparent text-base outline-none placeholder:opacity-60",
        className,
      )}
      {...props}
    />
  );
}

Input.displayName = "Input";
